import React from 'react';
import { withRouter } from 'react-router-dom';
import './styles.scss';
import RegisterForm from '../../forms/RegisterForm';

export class Register extends React.Component {
  render() {
    return (
      <div id="page-container" className="row align-items-center justify-content-center">
        <RegisterForm />
      </div>
    );
  }
}

export default withRouter(Register);


// WEBPACK FOOTER //
// ./src/components/pages/Register/Register.jsx